import {
  loadScriptOnce
} from "./chunk-JHUVX63K.mjs";
import {
  ApiConfig
} from "./chunk-IITKCRXL.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/grecaptcha/token.ts
var RECAPTCHA_SCRIPT_ID = "recaptcha_script";
var MISSING_KEY = "No reCAPTCHA v3 key found in config, please follow usage instruction in https://github.com/nadude/webook-frontend/blob/main/packages/api/README.md";
var NOT_LOADED = "Error loading recaptcha, please refresh and try again.";
var loadRecaptchaScript = () => __async(null, null, function* () {
  var _a, _b;
  const v3Key = (_b = (_a = ApiConfig.config) == null ? void 0 : _a.grecaptcha) == null ? void 0 : _b.v3Key;
  if (!v3Key) {
    throw new Error(MISSING_KEY);
  }
  if (typeof window === "undefined" || window.grecaptcha) return;
  yield loadScriptOnce(
    RECAPTCHA_SCRIPT_ID,
    `https://www.recaptcha.net/recaptcha/api.js?render=${v3Key}`
  );
});
var generateRecaptchaToken = (action = "unspecific") => {
  return new Promise((resolve, reject) => {
    var _a, _b;
    const v3Key = (_b = (_a = ApiConfig.config) == null ? void 0 : _a.grecaptcha) == null ? void 0 : _b.v3Key;
    if (!v3Key) {
      return reject(MISSING_KEY);
    }
    const execute = () => {
      try {
        grecaptcha.ready(
          () => grecaptcha.execute(v3Key, { action }).then((token) => {
            resolve(token);
          })
        );
      } catch (err) {
        console.log(err);
        reject(err);
      }
    };
    if (typeof grecaptcha !== "undefined") {
      return execute();
    }
    loadRecaptchaScript().then(execute, () => reject(NOT_LOADED));
  });
};

export {
  RECAPTCHA_SCRIPT_ID,
  loadRecaptchaScript,
  generateRecaptchaToken
};
//# sourceMappingURL=chunk-ZD2ESESY.mjs.map